export enum SalesOrderStatus {
  PENDING = 1,
  OPEN,
  CLOSE
}
